import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DocumentUploadForm from './DocumentUploadForm';
import { withTranslation } from 'react-i18next';
import Card from '../../common/components/Card';
import { Row, Col, Glyphicon } from 'react-bootstrap';

class DocumentsList extends Component {
    render() {
        const { t, documents, canAddDocuments, onAddDocument } = this.props;

        const parentDocuments = documents.filter(d => d.fromParent);
        return (<div>
            {(canAddDocuments || parentDocuments.length > 0) && <h4>{t('FO_IndividualConsultation_Documents')}</h4>}
            <Row>
                {parentDocuments.map(doc => {
                    const docName = !docName ? doc.type : doc.name;
                    return (<Col sm={6} key={doc.id}>
                        <a key={doc.id} target='blank' href={doc.url} className='no-decoration'>
                            <Card style={{ height: 100 }}>
                                <Glyphicon glyph='download-alt' className='pull-right' />
                                <h4>{doc.friendlyFilename}</h4>
                            </Card>
                        </a>
                    </Col>);
                })}
            </Row>
            {canAddDocuments && <Row><Col sm={12} id='new-doc'>
                <Card className='card-dashed'>
                    <DocumentUploadForm onSubmit={onAddDocument} />
                </Card>
            </Col></Row>}
        </div>);
    }
}

DocumentsList.propTypes = {
    documents: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        type: PropTypes.string,
        name: PropTypes.string,
        friendlyFilename: PropTypes.string
    })),
    canAddDocuments: PropTypes.bool,
    onAddDocument: PropTypes.func
};

export default withTranslation()(DocumentsList);